<template>
  <summary-detail :name="brandName" type="品牌" :year="year">
    <div>
      <platform-count :year="year" :brand-name="this.brandName" :organization-id="organization_id"/>
      <br/>
      <platform-money :year="year" :brand-name="this.brandName" :organization-id="organization_id"/>
      <br/>
      <ChartBrandArtistRank :year="year" :brand-name="this.brandName" :organization-id="organization_id"/>
    </div>
  </summary-detail>
</template>

<script>

import ChartBrandArtistRank from "@/views/dashboard/components/ChartBrandArtistRank";
import SummaryDetail from "@/views/dashboard/components/Detail.vue";
import PlatformCount from "@/components/summary/detail/platformCount.vue";
import PlatformMoney from "@/components/summary/detail/platformMoney.vue";

export default {
  name: "SummaryBrandDetail",
  components: {
    PlatformMoney, PlatformCount, SummaryDetail, ChartBrandArtistRank,
  },
  data() {
    return {
      brandName: this.$route.query.brandName,
      year: this.$route.query.year,
      organization_id: this.$route.query.organization_id || 'ALL',
      sticky: false,

    }
  }
}
</script>

<style>

</style>
